export default __webpack_public_path__ + "static/media/bg.97d0fc90.webp";